export default __webpack_public_path__ + "static/media/user-lisa.25db10ce.png";